import { HorizontalBar, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

/**
 * Tiny generic horizontal bar chart wrapper, following the extend pattern of
 * src/components/settings/analytics/LineChart.vue. The reactiveProp mixin
 * provides the `chartData` prop and re-renders on data changes.
 */
export default {
  extends: HorizontalBar,
  mixins: [reactiveProp],
  props: {
    options: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};
